import { patchRequest } from 'utils/api/apiRequest'
import { Profile } from 'utils/api/User/getCurrentUser'

interface PatchUser {
  language_id: number
}
export const patchUser = ({ language_id }: PatchUser) =>
  patchRequest<Profile, PatchUser>('/users/update-data', { language_id })
